import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Check } from '@mui/icons-material';
import { FunctionComponent } from 'react';

import { PaletteColor, Size } from '../../styling/AppStyles';

const ExinStepIconContainer = styled.div<{ isHighlighted: boolean }>`
  width: ${Size.medium};
  min-width: ${Size.medium};
  height: ${Size.medium};
  box-sizing: border-box;
  border: 2px solid ${PaletteColor.text};
  border-radius: 50%;
  user-select: none;
  white-space: nowrap;

  line-height: calc(${Size.medium} - 2 * 2px);
  text-align: center;
  & > svg {
    /* It just looks better this way; */
    transform: translateY(2px);
  }

  ${({ isHighlighted }) =>
    isHighlighted
      ? css`
          background-color: ${PaletteColor.text};
          color: ${PaletteColor.white};
        `
      : css`
          background-color: ${PaletteColor.white};
          color: ${PaletteColor.text};
        `}
`;

const ExinStepIcon: FunctionComponent<{
  isHighlighted: boolean;
  isCompleted: boolean;
  number: number;
}> = ({ isCompleted, isHighlighted, number }) => {
  return (
    <ExinStepIconContainer isHighlighted={isHighlighted}>
      {isCompleted ? <Check /> : number}
    </ExinStepIconContainer>
  );
};

export default ExinStepIcon;
